<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="bannerDetail.name"
                    filled
                    label="Name"
                    placeholder="Enter article title"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="bannerDetail.description"
                    filled
                    label="Description"
                    placeholder="Enter article description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-file-input
                    v-model="bannerDetail.photo_url_first"
                    label="Ảnh 1"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="fileSelected1"
                ></v-file-input>
                <v-img :class="[src1 ? 'mb-8':'d-none']" :src="src1" contain aspect-ratio="1.7" width="200"
                ></v-img>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="bannerDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên bài viết"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="bannerDetail.description_vi"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả"
                ></v-textarea>
              </v-col>
              <!--          <v-col cols="12">-->
              <!--            <v-file-input-->
              <!--                v-model="bannerDetail.photo_url_second"-->
              <!--                label="Ảnh 2"-->
              <!--                placeholder="Tải ảnh lên"-->
              <!--                prepend-icon="mdi-camera"-->
              <!--                @change="fileSelected2"-->
              <!--            ></v-file-input>-->
              <!--            <v-img :class="[src2 ? 'mb-8':'d-none']" :src="src2" contain aspect-ratio="1.7"-->
              <!--            ></v-img>-->
              <!--          </v-col>-->
            </v-col>
          </v-row>
          <v-col class="text-center" cols="12">
            <v-btn color="primary" width="180" @click="save()"> Lưu</v-btn>
          </v-col>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_BANNER, UPDATE_BANNER} from "@/store/modules/banner";
import {UPLOAD_IMAGE} from "@/store/modules/field_project";


export default {
  components: {},
  data() {
    return {
      page: " Top banner",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Top banner",
          disabled: false,
        },
      ],

      url: '',

      src1: "",
      image1: {},
      hasImage1: false,
      img1: true,
      img1_2: false,

      src2: "",
      image2: {},
      hasImage2: false,
      img2: true,
      img2_2: false,

    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated", "bannerDetail"
    ]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({name: "login"});
    }
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_BANNER, 1);
  },
  watch: {
    bannerDetail(val) {
      if (val && val.photo_url_first) {
        this.src1 = this.url + val.photo_url_first;
        this.img1_2 = false;
      }
      if (val && val.photo_url_second) {
        this.src2 = this.url + val.photo_url_second;
        this.img2_2 = false;
      }
    },
  },
  methods: {
    fileSelected1(event) {
      if (!event) {
        this.src1 = "";
        this.bannerDetail.photo_url_first = "";
        this.img1_2 = true;
      }
      this.img1_2 = true;
      this.img1 = false;
      this.image1 = event;
      this.src1 = URL.createObjectURL(this.image1);
      if (this.image1) {
        this.hasImage1 = !this.hasImage1;
      }
      this.$toasted.info('Please wait while the image loads...', {
        duration: 2000,
        position: 'top-center'
      })
      let formData = new FormData();
      formData.append("upload", this.image1);
      formData.append("type", "ckeditor");
      formData.append("position_type", "1");
      this.$store.dispatch(`${UPLOAD_IMAGE}`, formData).then((data) => {
        this.bannerDetail.photo_url_first = data.data.data[0].path;
      });
    },
    fileSelected2(event) {
      if (!event) {
        this.src2 = "";
        this.bannerDetail.photo_url_second = "";
        this.img2_2 = true;
      }
      this.img2_2 = true;
      this.img2 = false;
      this.image2 = event;
      this.src2 = URL.createObjectURL(this.image2);
      if (this.image2) {
        this.hasImage2 = !this.hasImage2;
      }
      this.$toasted.info('Please wait while the image loads...', {
        duration: 2000,
        position: 'top-center'
      })
      let formData = new FormData();
      formData.append("upload", this.image2);
      formData.append("type", "ckeditor");
      formData.append("position_type", "1");
      this.$store.dispatch(`${UPLOAD_IMAGE}`, formData).then((data) => {
        this.bannerDetail.photo_url_second = data.data.data[0].path;
      });
    },
    async save() {
      let data = {
        id: 1,
        name: this.bannerDetail.name,
        name_vi: this.bannerDetail.name_vi,
        description: this.bannerDetail.description,
        description_vi: this.bannerDetail.description_vi,
        photo_url_first: this.bannerDetail.photo_url_first,
        photo_url_second: this.bannerDetail.photo_url_second,
      }
      await this.$store.dispatch(`${UPDATE_BANNER}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/banner/1')
        } else {
          alert(data.data.errors)
        }
      });
    }

  }
};
</script>
<style lang="scss">
.home-content {
  background: #ffffff !important;
}

.min-width {
  min-width: 90% !important;
}
</style>
